export const checkStgUrl = (val, condition) => {
    if (condition) {
        // check เปิดได้เลย on stg || local
        return val.indexOf("dev.muic.io") > 0 || val.indexOf("localhost") > 0
    } else {
        // ไม่ check เปิดได้เลย on prod
        return true
    }
}
